<template>
  <div class="deduct-record-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="filter-group">
            <el-select v-model="searchLeaderId" placeholder="创作者ID" clearable filterable class="filter-input-id" @change="handleSearch">
              <el-option v-for="l in leaders" :key="l.id" :label="l.id + ' - ' + (l.nickname || '')" :value="l.id" />
            </el-select>
            <el-date-picker
              v-model="searchRecordDate"
              type="date"
              placeholder="统计日期"
              value-format="yyyy-MM-dd"
              clearable
              @change="handleSearch"
            />
            <el-select v-model="searchStatus" placeholder="状态" clearable class="filter-select-sm" @change="handleSearch">
              <el-option label="已处理" :value="1" />
              <el-option label="待处理" :value="0" />
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="refreshList">刷新</el-button>
          </div>
        </div>
      </div>

      <el-table :data="list" border stripe v-loading="loading" row-key="id">
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column prop="recordDate" label="统计日期" min-width="110" align="center" />
        <el-table-column prop="leaderId" label="创作者ID" min-width="100" align="center" />
        <el-table-column label="原始总收益" min-width="110" align="center">
          <template slot-scope="scope">{{ formatAmount(scope.row.totalEcpm) }}</template>
        </el-table-column>
        <el-table-column label="扣量金额" min-width="100" align="center">
          <template slot-scope="scope">{{ formatAmount(scope.row.deductAmount) }}</template>
        </el-table-column>
        <el-table-column label="实际收入" min-width="100" align="center">
          <template slot-scope="scope">
            <span class="income-text">{{ formatAmount(scope.row.finalIncome) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" type="success" size="small" effect="plain">已处理</el-tag>
            <el-tag v-else-if="scope.row.status === 0" type="info" size="small" effect="plain">待处理</el-tag>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="记录时间" min-width="160" align="center" />
      </el-table>

      <div v-if="pagination.total > 0" class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { get } from '@/utils/http'

export default {
  name: 'DeductRecordManagement',
  data() {
    return {
      list: [],
      loading: false,
      searchLeaderId: '',
      searchRecordDate: '',
      searchStatus: '',
      leaders: [],
      pagination: { page: 1, pageSize: 10, total: 0 }
    }
  },
  mounted() {
    this.fetchLeaders()
    this.fetchList()
  },
  methods: {
    async fetchLeaders() {
      try {
        const result = await get('/admin/users', { role: 1, page: 1, pageSize: 500 })
        const data = result.data || {}
        this.leaders = Array.isArray(data.users) ? data.users : []
      } catch (e) {
        this.leaders = []
      }
    },
    formatAmount(val) {
      if (val == null || val === '') return '-'
      return (val / 1000).toFixed(2)
    },
    async fetchList() {
      this.loading = true
      try {
        const params = { page: this.pagination.page, pageSize: this.pagination.pageSize }
        if (this.searchLeaderId) params.leaderId = this.searchLeaderId
        if (this.searchRecordDate) params.recordDate = this.searchRecordDate
        if (this.searchStatus !== '') params.status = this.searchStatus
        const result = await get('/admin/deduct-record/list', params)
        const data = result.data || {}
        this.list = Array.isArray(data.records) ? data.records : []
        this.pagination.total = data.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    refreshList() {
      this.searchLeaderId = ''
      this.searchRecordDate = ''
      this.searchStatus = ''
      this.pagination.page = 1
      this.fetchList()
    },
    handlePageChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.pagination-container { margin-top: 16px; text-align: right; }
.income-text { font-weight: 600; color: #67c23a; }
.text-muted { color: #c0c4cc; }

/* ===== 卡片 ===== */
.deduct-record-management {
  padding: 4px;
}
.deduct-record-management ::v-deep > .el-card {
  border-radius: 8px;
}

/* ===== 搜索栏 ===== */
.deduct-record-management .filter-card {
  margin-bottom: 16px;
}
.deduct-record-management .filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 16px 20px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e8ecf1;
}
.deduct-record-management .filter-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  flex: 1;
}

/* ===== 表格 ===== */
.deduct-record-management ::v-deep .el-table {
  border-radius: 6px;
  overflow: hidden;
}
.deduct-record-management ::v-deep .el-table::before {
  display: none;
}

/* ===== 响应式 - 中屏 ===== */
@media (max-width: 1100px) {
  .deduct-record-management .filter-bar {
    flex-direction: column;
    align-items: stretch;
  }
  .deduct-record-management .filter-group {
    flex-wrap: wrap;
  }
}

/* ===== 响应式 - 小屏 ===== */
@media (max-width: 768px) {
  .deduct-record-management .filter-bar {
    padding: 12px;
    flex-direction: column;
    align-items: stretch;
  }
  .deduct-record-management .filter-group {
    flex-direction: column;
    align-items: stretch;
  }
  .deduct-record-management .filter-group > * {
    width: 100% !important;
    max-width: 100% !important;
  }
  .deduct-record-management .pagination-container {
    overflow-x: auto;
    text-align: center;
  }
}
</style>
